import styled from 'styled-components'
import { colors } from '../../../lib/colors'
import { BET_BUTTONS_STYLED_PROPS } from './interface'

export const BetButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 14px;
`

export const BetButton = styled.div<BET_BUTTONS_STYLED_PROPS>`
  position: relative;
  display: flex;
  justify-content: center;
  /* align-items: center; */
  cursor: ${({ isDisabled }) => (isDisabled ? '' : 'pointer')};
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${({ width }) => width || '150px'};
    height: 36px;
    font-size: 13px;
    border-radius: 50px;
    text-transform: uppercase;
    opacity: ${({ isDisabled }) => (isDisabled ? 0.6 : 1)};
    cursor: ${({ isDisabled }) => (isDisabled ? '' : 'pointer')};
    pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
    background: ${({ leftButton }) =>
      leftButton ? colors.primaryDark : colors.secondary};
    color: ${({ leftColor }) => (leftColor ? leftColor : colors.primaryDark)};
    transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
  }
  :active {
    .btn {
      transform: scale(0.65);
      transition: transform 0.16s;
      transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
    }
    .white {
      opacity: 0.5;
      transform: scale(0.65);
      transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
      transition: transform 0.16s;
    }
  }
  .white {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background: #ffffff;
    opacity: 0;
    transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
    transition: transform 0.16s;
    pointer-events: none;
  }
  svg {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    transform: ${({ leftButton }) =>
      leftButton ? 'rotate(0deg)' : 'rotateX(180deg)'};
    path {
      stroke: ${({ leftButton }) =>
        leftButton ? colors.quaternary : colors.primaryDark};
    }
  }
  .deal-rebet {
    margin-right: 4px;
  }
`
export const AnimatedText = styled.p<BET_BUTTONS_STYLED_PROPS>`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  z-index: 1;
  pointer-events: none;
  animation: ${({ fadeIn }) => (fadeIn ? 'fadeIn' : 'fadeOut')};
  animation-duration: 330ms;
  animation-fill-mode: forwards;
  ${p =>
    p.anim
      ? 'transform: scale(0.65); pointer-events: none'
      : 'transform: scale(1); '};
  transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
  transition: transform 167ms;

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fadeOut {
    0% {
      opacity: 1;
      transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
    }
    100% {
      opacity: 0;
    }
  }
`
